import { JavaLong } from '../../../../java/lang/JavaLong';
import { JavaObject } from '../../../../java/lang/JavaObject';
import { Class } from '../../../../java/lang/Class';

export class GostKursklausur extends JavaObject {

	/**
	 * Die ID der Kursklausur.
	 */
	public id: number = -1;

	/**
	 * Die ID der Klausur-Vorgabe.
	 */
	public idVorgabe: number = -1;

	/**
	 * Die ID des Klausurkurses.
	 */
	public idKurs: number = -1;

	/**
	 * Die ID des Klausurtermins, sofern schon gesetzt.
	 */
	public idTermin: number | null = null;

	/**
	 * Die Startzeit der Klausur in Minuten seit 0 Uhr, sofern abweichend von Startzeit des gesamten Termins.
	 */
	public startzeit: number | null = null;

	/**
	 * Die textuelle Bemerkung zur Kursklausur, sofern vorhanden.
	 */
	public bemerkung: string | null = null;


	/**
	 * Default-Konstruktor
	 */
	public constructor() {
		super();
	}

	/**
	 * Vergleicht, ob das aktuelle dasselbe Objekt, wie ein anderes übergebenes Objekt ist.
	 *
	 * @param another     das zu vergleichende Objekt
	 * @return true, falls die Objekte identisch sind, sonst false
	 */
	public equals(another: unknown | null): boolean {
		return (((another instanceof JavaObject) && (another.isTranspiledInstanceOf('de.svws_nrw.core.data.gost.klausurplanung.GostKursklausur')))) && (this.id === (another as unknown as GostKursklausur).id);
	}

	/**
	 * Erzeugt den Hashcode zu Objekt auf Basis der id.
	 *
	 * @return den HashCode
	 */
	public hashCode(): number {
		return JavaLong.hashCode((this.id));
	}

	transpilerCanonicalName(): string {
		return 'de.svws_nrw.core.data.gost.klausurplanung.GostKursklausur';
	}

	isTranspiledInstanceOf(name: string): boolean {
		return ['de.svws_nrw.core.data.gost.klausurplanung.GostKursklausur'].includes(name);
	}

	public static readonly class = new Class<GostKursklausur>('de.svws_nrw.core.data.gost.klausurplanung.GostKursklausur');

	public static transpilerFromJSON(json: string): GostKursklausur {
		const obj = JSON.parse(json) as Partial<GostKursklausur>;
		const result = new GostKursklausur();
		if (obj.id === undefined)
			throw new Error('invalid json format, missing attribute id');
		result.id = obj.id;
		if (obj.idVorgabe === undefined)
			throw new Error('invalid json format, missing attribute idVorgabe');
		result.idVorgabe = obj.idVorgabe;
		if (obj.idKurs === undefined)
			throw new Error('invalid json format, missing attribute idKurs');
		result.idKurs = obj.idKurs;
		result.idTermin = (obj.idTermin === undefined) ? null : obj.idTermin === null ? null : obj.idTermin;
		result.startzeit = (obj.startzeit === undefined) ? null : obj.startzeit === null ? null : obj.startzeit;
		result.bemerkung = (obj.bemerkung === undefined) ? null : obj.bemerkung === null ? null : obj.bemerkung;
		return result;
	}

	public static transpilerToJSON(obj: GostKursklausur): string {
		let result = '{';
		result += '"id" : ' + obj.id.toString() + ',';
		result += '"idVorgabe" : ' + obj.idVorgabe.toString() + ',';
		result += '"idKurs" : ' + obj.idKurs.toString() + ',';
		result += '"idTermin" : ' + ((obj.idTermin === null) ? 'null' : obj.idTermin.toString()) + ',';
		result += '"startzeit" : ' + ((obj.startzeit === null) ? 'null' : obj.startzeit.toString()) + ',';
		result += '"bemerkung" : ' + ((obj.bemerkung === null) ? 'null' : JSON.stringify(obj.bemerkung)) + ',';
		result = result.slice(0, -1);
		result += '}';
		return result;
	}

	public static transpilerToJSONPatch(obj: Partial<GostKursklausur>): string {
		let result = '{';
		if (obj.id !== undefined) {
			result += '"id" : ' + obj.id.toString() + ',';
		}
		if (obj.idVorgabe !== undefined) {
			result += '"idVorgabe" : ' + obj.idVorgabe.toString() + ',';
		}
		if (obj.idKurs !== undefined) {
			result += '"idKurs" : ' + obj.idKurs.toString() + ',';
		}
		if (obj.idTermin !== undefined) {
			result += '"idTermin" : ' + ((obj.idTermin === null) ? 'null' : obj.idTermin.toString()) + ',';
		}
		if (obj.startzeit !== undefined) {
			result += '"startzeit" : ' + ((obj.startzeit === null) ? 'null' : obj.startzeit.toString()) + ',';
		}
		if (obj.bemerkung !== undefined) {
			result += '"bemerkung" : ' + ((obj.bemerkung === null) ? 'null' : JSON.stringify(obj.bemerkung)) + ',';
		}
		result = result.slice(0, -1);
		result += '}';
		return result;
	}

}

export function cast_de_svws_nrw_core_data_gost_klausurplanung_GostKursklausur(obj: unknown): GostKursklausur {
	return obj as GostKursklausur;
}
